import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import style from './index.module.scss';

export const AlertMessage = () => {
  const employeeErrors = useAppSelector(uiModel.Absence.selectors.getEmployeeErrors);
  const dateInvalidErrors = useAppSelector(uiModel.Absence.selectors.getInvalidDateErrors);
  const duplicateErrors = useAppSelector(uiModel.Absence.selectors.getDuplicateErrors);
  const intervalErrors = useAppSelector(uiModel.Absence.selectors.getIntervalErrors);

  return !!employeeErrors.length ||
    !!dateInvalidErrors.length ||
    !!duplicateErrors.length ||
    !!intervalErrors.length ? (
    <div>
      <div className={style.messages}>
        {!!employeeErrors.length && (
          <Alert
            icon={<ExclamationCircleOutlined />}
            message={`Сотрудник не определен: ${employeeErrors?.length}`}
            description={(() => {
              if (employeeErrors?.length === 1) {
                return `Неявкa ${employeeErrors[0].tableId} не будет загружена`;
              } else {
                return `Неявки ${employeeErrors?.map(item => item.tableId)} не будут загружены`;
              }
            })()}
            type="error"
            showIcon
          />
        )}
        {!!dateInvalidErrors.length && (
          <Alert
            icon={<ExclamationCircleOutlined />}
            message={`Некорректная дата: ${dateInvalidErrors?.length}`}
            description={`Укажите период отсутствия в строке ${dateInvalidErrors.map(item => item.tableId)}`}
            type="error"
            showIcon
          />
        )}
        {!!duplicateErrors.length && (
          <Alert
            icon={<ExclamationCircleOutlined />}
            message={`Дубликаты: ${duplicateErrors?.length}`}
            description={`Укажите период отсутствия в строке ${duplicateErrors.map(item => item.tableId)}`}
            type="error"
            showIcon
          />
        )}
        {!!intervalErrors.length && (
          <Alert
            icon={<ExclamationCircleOutlined />}
            message={`Пересечение дат в периоде: ${intervalErrors?.length}`}
            description={`Укажите период отсутствия в строке ${intervalErrors.map(item => item.tableId)}`}
            type="error"
            showIcon
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};
